import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  internalServerErrorSection: {
    alignItems: 'center',
    display: 'flex',
    minHeight: 'calc(100vh - 170px)',
    textAlign: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    [Theme.breakpoints.down('sm')]: {
      margin: '0 20px',
    },
  },
  internalServerErrorHeader: {
    fontFamily: Theme.typography.base.semiBold,
    fontSize: Theme.typography.size[9],
    lineHeight: '150%',
    color: Theme.palette.primary.main,
    [Theme.breakpoints.down('lg')]: {
      fontSize: Theme.typography.size[7],
    },

    [Theme.breakpoints.down('sm')]: {
      fontSize: Theme.typography.size[6],
    },
  },
  internalServerErrorDescription: {
    fontFamily: Theme.typography.base.regular,
    fontSize: Theme.typography.size[3],
    lineHeight: '150%',
    color: Theme.palette.gray[750],
    [Theme.breakpoints.down('lg')]: {
      fontSize: Theme.typography.size[2],
    },
  },
}));

export default useStyles;
